import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import resources from "../resources/Content";
import backgroundVideo from "../assets/videos/video3.mp4";

const Blog = () => {
  const [activePost, setActivePost] = useState(null);

  // Scroll to top whenever a blog post opens
  useEffect(() => {
    if (activePost) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [activePost]);

  const ActivePostComponent = activePost?.component;
  const { heading, posts } = resources.blog;

  return (
    <section className="relative w-full bg-black text-white backdrop-blur-md min-h-screen pt-[120px] pb-20 px-4 md:px-20 overflow-hidden">
      
      {/* Background Video */}
      <video
        className="absolute inset-0 w-full h-full object-cover z-0"
        src={backgroundVideo}
        autoPlay
        loop
        muted
        playsInline
      />

      {/* Overlay to darken video */}
      <div className="absolute inset-0 bg-black/50 z-0" />
      {/* Header Content */}
      {!activePost && (
        <div className="relative z-[10] flex flex-col items-center justify-center mb-20 text-white">
         <h3 className="text-[50px] text-center sm:text-[80px] md:text-[130px] lg:text-[200px] font-bold text-gray-300/10 leading-none select-none pointer-events-none">
          MOUNTAIN SPIRIT SERIES
        </h3>

          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center max-w-3xl"
          >
            <h1 className="text-5xl md:text-7xl font-bold leading-tight drop-shadow-xl">
              {heading.title}
            </h1>
            <p className="mt-6 text-lg md:text-xl text-gray-100">
              {heading.subtitle}
            </p>
          </motion.div>
        </div>
      )}

      {/* Blog Cards */}
      {!activePost && (
        <div className="relative z-[10] max-w-[900px] mx-auto grid grid-cols-1 md:grid-cols-2 gap-8">
          {posts.map((post) => (
            <motion.div
              key={post.id}
              className="relative block rounded-[16px] overflow-hidden border border-white/10 bg-white/5 backdrop-blur-sm shadow-lg p-7 cursor-pointer"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              onClick={() => setActivePost(post)}
            >
              <div className="relative h-56 md:h-64 w-full rounded-[12px] overflow-hidden mb-4">
                <img
                  src={post.imageUrl}
                  alt={post.title}
                  className="w-full h-full object-cover rounded-[12px]"
                  loading="lazy"
                />
              </div>

              <div className="inline-block mb-3 px-3 py-1 rounded-md text-xs font-medium border border-gray-700 bg-black/70 backdrop-blur-sm">
                {post.category}
              </div>

              <h2 className="text-white font-semibold text-lg md:text-xl leading-snug">
                {post.title}
              </h2>
            </motion.div>
          ))}
        </div>
      )}

      {/* Single Blog Active Post */}
      <AnimatePresence>
        {activePost && ActivePostComponent && (
          <div className="relative z-[20]">
            <React.Suspense
              fallback={
                <div className="text-center mt-20 text-white">
                  Loading...
                </div>
              }
            >
              <ActivePostComponent onBack={() => setActivePost(null)} />
            </React.Suspense>
          </div>
        )}
      </AnimatePresence>
    </section>
  );
};

export default Blog;
